import React, {useState} from 'react';
import {Box, Button, Grid, Link, Typography} from '@mui/material';
import {withSnackbar} from "../../hocs/withSnackbar";
import {getAgreementUrl} from '../../../util/BookingUtil.ts';
import RentalAgreementCheckbox from "../../RentalAgreementCheckbox";
import {BookDetailsRow, PaymentHeading, PaymentTitle} from '../style'
import {formatMoneyAddDecimalPointAndThousands} from "../../../util/PaymentUtils";

const BookingPayment = ({ booking, paymentMethodId, paymentTotals, handleMakePayment }) => {
  const [tosAgreed, setTosAgreed] = useState(false);

  const onTosChange = (e) => {
    setTosAgreed(e.target.checked);
  }

  return (
    <Box>
      <Grid item container direction={'column'} justifyContent='space-between' alignItems='center'>
        <PaymentHeading>
          Totals
        </PaymentHeading>

        <BookDetailsRow container justifyContent='space-between' alignItems='flex-end'>
          <Grid container justifyContent='space-between' alignItems='center'>
            <PaymentTitle>{"Number of Transactions"}</PaymentTitle>
            <PaymentTitle>{`${paymentTotals.count}`}</PaymentTitle>
          </Grid>
          <Grid container justifyContent='space-between' alignItems='center'>
            <PaymentTitle>{"Service Charges"}</PaymentTitle>
            <PaymentTitle>{`${formatMoneyAddDecimalPointAndThousands(paymentTotals.charge)}`}</PaymentTitle>
          </Grid>
          <Grid container justifyContent='space-between' alignItems='center'>
            <PaymentTitle>{"Fees"}</PaymentTitle>
            <PaymentTitle>{`${formatMoneyAddDecimalPointAndThousands(paymentTotals.transactionFee)}`}</PaymentTitle>
          </Grid>
          <Grid container justifyContent='space-between' alignItems='center'>
            <PaymentTitle>{"Taxes"}</PaymentTitle>
            <PaymentTitle>{`${formatMoneyAddDecimalPointAndThousands(paymentTotals.tax)}`}</PaymentTitle>
          </Grid>
          <Grid container justifyContent='space-between' alignItems='center'>
            <PaymentTitle>{"Total Charge"}</PaymentTitle>
            <PaymentTitle>{`${formatMoneyAddDecimalPointAndThousands(paymentTotals.total)}`}</PaymentTitle>
          </Grid>
        </BookDetailsRow>

        <Typography>Accept <Link to={'/terms-of-use'} target={"_blank"}>Terms of Service</Link> Agreement</Typography>
        <RentalAgreementCheckbox
          checked={tosAgreed}
          required
          agreementUrl={getAgreementUrl(booking)}
          onChange={onTosChange}
          error={''}
        />
        <Button
            onClick={handleMakePayment}
            variant="contained"
            color="secondary"
            disabled={!tosAgreed || !paymentMethodId.length}
            sx={{ mt:3 }}
          >
            Make Payment
          </Button>
      </Grid>
    </Box>
  )
}

export default withSnackbar(BookingPayment)
